
    import '/vercel/path0/docs/demo/pure.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-demo-pure-demo-pure"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/demo/pure.md?type=demo')
};